
import store from "@/store";
import {computed, toRefs} from "vue";
import SvgIcon from "@/components/common/SvgIcon.vue";
import OfferOverviewSingle from "@/components/member/offer/OfferOverviewSingle.vue";
import {useI18n} from "vue-i18n";

export default {
  name: "OfferOverview",
  components: {OfferOverviewSingle, SvgIcon},
  props: {
    // true: Privilege, false: Birthday Offer
    isPrivilege: {
      type: Boolean,
      default: true,
    }
  },
  setup(props: any) {
    const {isPrivilege} = toRefs(props);
    const {t} = useI18n();
    const type = computed(() => store.state.selectedType);
    const list = computed(() => {
      const memberData = store.state.memberData[type.value];
      if (memberData) {
        return (isPrivilege.value ? memberData.privileges : memberData.bDayOffer)?.slice(0, 3);
      } else {
        return [];
      }
    });

    const title = computed(() =>
        isPrivilege.value ? t('privileges') : t('birthday-offer')
    )
    const allOffer = computed(() =>
        isPrivilege.value ? t("privileges") : t("offers")
    )
    const link = computed(() =>
        isPrivilege.value ? "privilege" : "offer"
    )

    return {
      list,
      title,
      allOffer,
      link
    }
  }
}
